"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.bindTagSelect = bindTagSelect;
exports.getComDetail = getComDetail;
exports.getproductList = getproductList;
exports.importChange = importChange;
exports.selectProducts = selectProducts;
exports.skuListArticle = skuListArticle;
var _request = _interopRequireDefault(require("@/utils/request"));
var _index = require("@/utils/index");
var _excluded = ["spuId", "skuId", "productName", "keywords"]; // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    cateId = _ref.cateId,
    keywords = _ref.keywords,
    page = _ref.page,
    limit = _ref.limit,
    productType = _ref.productType,
    skuCode = _ref.skuCode;
  var data = {
    cateId: cateId,
    keywords: keywords,
    page: page,
    limit: limit,
    productType: productType,
    skuCode: skuCode
  };
  return (0, _request.default)({
    url: '/admin/store/product/list',
    method: 'GET',
    params: data
  });
}

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(data) {
  return (0, _request.default)({
    url: '/admin/business/supplierProduct/import',
    method: 'post',
    data: data
  });
}

/**
 * 选择商品
 */
function selectProducts(data) {
  return (0, _request.default)({
    url: '/admin/business/supplierProduct/saveByIds',
    method: 'post',
    data: data
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(data) {
  return (0, _request.default)({
    url: '/admin/business/supplierProduct/update',
    method: 'post',
    data: data
  });
}

/**
 * 删除
 * @param ids
 * @constructor
 */
function DelArticle(productIds) {
  return (0, _request.default)({
    url: '/admin/business/supplierProduct/deleteBatch',
    method: 'post',
    data: {
      productIds: productIds
    }
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
function getComDetail(id) {
  return (0, _request.default)({
    url: '/admin/business/supplierProduct/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 查询卡券供应商产品列表
 * @param pram
 * @constructor
 */
function getproductList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/business/supplierProduct/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 导入创建销售商商品
 * @param {*} data
 * @returns
 */
function importChange(data) {
  return (0, _request.default)({
    url: '/admin/import/excel/product',
    method: 'post',
    data: data
  });
}

/**
 * 商品sku列表
 * @param pram
 * @constructor
 */
function skuListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = pram || {},
    cateId = _ref2.cateId,
    keywords = _ref2.keywords,
    brandId = _ref2.brandId,
    skuCode = _ref2.skuCode,
    skuName = _ref2.skuName,
    supplierId = _ref2.supplierId,
    page = _ref2.page,
    limit = _ref2.limit,
    productType = _ref2.productType,
    id = _ref2.id;
  var data = {
    cateId: cateId,
    keywords: keywords,
    brandId: brandId,
    skuCode: skuCode,
    skuName: skuName,
    supplierId: supplierId,
    page: page,
    limit: limit,
    productType: productType,
    id: id // 添加ID参数用于按SKU ID搜索
  };
  return (0, _request.default)({
    url: '/admin/store/sku/list',
    method: 'GET',
    params: data,
    paramsSerializer: function paramsSerializer(params) {
      return (0, _index.param)(params);
    }
  });
}

/**
 * 选择商品
 */
function bindTagSelect() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = data || {},
    spuId = _ref3.spuId,
    skuId = _ref3.skuId,
    productName = _ref3.productName,
    keywords = _ref3.keywords,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var params = _objectSpread(_objectSpread({}, rest), {}, {
    spuId: spuId,
    skuId: skuId,
    productName: productName || keywords,
    keyword: productName || keywords
  });
  delete params.supplierId;
  delete params.keywords;
  return (0, _request.default)({
    url: '/admin/store/label/bind/select/list',
    method: 'get',
    params: params
  }).then(function () {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var resultres = _objectSpread(_objectSpread({}, res), {}, {
      list: res && res.list.length ? res.list.map(function (item) {
        var _ref4 = item || {},
          category = _ref4.category,
          code = _ref4.code,
          image = _ref4.image,
          name = _ref4.name,
          price = _ref4.price;
        return _objectSpread(_objectSpread({}, item), {}, {
          skuCode: code,
          skuName: name,
          cateName: category,
          otPrice: price
        });
      }) : []
    });
    return resultres;
  });
}